import $ from 'jquery'

function ChartHierarchicalSelectorsSectionStrategy() {}

ChartHierarchicalSelectorsSectionStrategy.prototype.init = function({
    container,
    leaveTypesSelector,
    noteMsgContainer,
    includeOtherUsersCheckbox,
    cpSelector,
}) {
    this.container = container;
    this.leaveTypesSelector = leaveTypesSelector;
    this.noteMsgContainer = noteMsgContainer;
    this.includeOtherUsersCheckbox = includeOtherUsersCheckbox;
    this.cpSelector = cpSelector;

    return this;
};

ChartHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI = function() {
    $(this.container).removeClass(
        this.getVisibleTaskUsersSelectorClassName() + " " +
        this.getVisibleBalanceUsersSelectorClassName() + " " +
        this.getVisibleBillingUsersSelectorClassName() + " " +
        this.getVisibleOvertimeUsersSelectorClassName() + " " +
        this.getVisibleCPSelectorClassName() + " " +
        this.getVisibleLeaveTypesSelectorClassName() + " " +
        this.getVisibleNoteMsgClassName() + " " +
        this.getVisibleUserSelectorInfoIconClassName() + " " +
        this.getVisibleIncludeOtherUsersCheckboxClassName()
    )
}

ChartHierarchicalSelectorsSectionStrategy.prototype.withUserSelector = function() {
    return false
}

ChartHierarchicalSelectorsSectionStrategy.prototype.getUserSelection = function() {
    return {}
}

ChartHierarchicalSelectorsSectionStrategy.prototype.getSelectedParams = function()
{
    // abstract
};

ChartHierarchicalSelectorsSectionStrategy.prototype.validate = function()
{
    return [];
};

ChartHierarchicalSelectorsSectionStrategy.prototype.validateIsUserSelected = function() {
    return false
}

ChartHierarchicalSelectorsSectionStrategy.prototype.isShowIncludeOtherUsersCheckbox = function() {
    return false
}

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleBalanceUsersSelectorClassName = function() {
    return "withBalanceUsersSelector"
}

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleBillingUsersSelectorClassName = function() {
    return "withBillingUsersSelector"
}

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleTaskUsersSelectorClassName = function() {
    return "withTaskUsersSelector"
}

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleOvertimeUsersSelectorClassName = function()
{
    return "withOvertimeUsersSelector";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleCPSelectorClassName = function() {
    return "withCPSelector"
}

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleLeaveTypesSelectorClassName = function()
{
    return "withLeaveTypesSelector";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleNoteMsgClassName = function()
{
    return "withNoteMsg";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleUsernameClassName = function() {
    return "withUsername"
}

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleUserSelectorInfoIconClassName = function()
{
    return "withUserSelectorInfoIcon";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleIncludeOtherUsersCheckboxClassName = function()
{
    return "withIncludeOtherUsersCheckbox";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.setUserSelection = function(selection) {
    //abstract
}

export default ChartHierarchicalSelectorsSectionStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/ChartHierarchicalSelectorsSectionStrategy.js